import OurBelief from './OurBelief'

export default OurBelief
